import * as actions from './actions'
import { rawDataOrigin, RawDataState } from './model';
import { RawDataActions } from './actions'
import { environmentSelectorReducer } from '../../common/environment/reducer';
import { resourceSelectorReducer } from '../../common/resource/reducer';
import { resourceTargetSelectorReducer } from '../../common/resource/target/reducer';

const initialState: RawDataState = <RawDataState> {};

const environmentsReducer = environmentSelectorReducer(rawDataOrigin)
const resourcesReducer = resourceSelectorReducer(rawDataOrigin)
const resourceTargetsReducer = resourceTargetSelectorReducer(rawDataOrigin)

const reducer = (state: RawDataState = initialState, action: RawDataActions): RawDataState => {
  state = {
    ...state,
    environmentSelector: environmentsReducer(state.environmentSelector, action),
    resourceSelector: resourcesReducer(state.resourceSelector, action),
    targetsSelector: resourceTargetsReducer(state.targetsSelector, action)
  }

  switch (action.type) {
    case actions.Loading:
      return {
        ...state,
        isLoading: true
      };

    case actions.ChangeDate:
      return {
        ...state,
        selectedDate: action.payload.selectedDate
      };

    case actions.AllTargets:
      return {
        ...state,
        allTargets: action.payload.targets
      };

    case actions.ChangeLogFiles:
      return {
        ...state,
        logFiles: action.payload.logFiles,
        isLoading: false
      };

    default:
      return state
  }
};

export default reducer
